angular.module('ui.order.stepDetailedRouteContainer', [])

    .config(function ($stateProvider) {
        $stateProvider.state('client.step', {
            url: '/step?step',
            templateUrl: 'app/ui/order/stepDetailedView/stepDetailedRouteContainer/stepDetailedRouteContainer.html',
            data: {pageTitle: 'OrderManager: Step details'},
            controller: 'StepDetailedRouteContainerController',
            controllerAs: 'StepDetailedRouteContainerController'
        });
    })

    .controller('StepDetailedRouteContainerController', function ($scope, $stateParams, orderItemsGridSharedSettings) {
        orderItemsGridSharedSettings.setStepFilter($stateParams.step);
    })

;